import { render, staticRenderFns } from "./overview_168.vue?vue&type=template&id=8c15c9e6&scoped=true"
import script from "./overview_168.vue?vue&type=script&setup=true&lang=js"
export * from "./overview_168.vue?vue&type=script&setup=true&lang=js"
import style0 from "./overview_168.vue?vue&type=style&index=0&id=8c15c9e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c15c9e6",
  null
  
)

export default component.exports